import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function WhoIsForSection() {
  const isFor = ['Creyentes que sienten que su fe se ve opacada por el agotamiento y el desgano.', 'Profesionales que cumplen con todo pero colapsan cada mañana en privado.', 'Personas que sufren de parálisis por análisis y fatiga crónica.', 'Quienes buscan una herramienta práctica que combine ciencia somática y Biblia.'];
  const isNotFor = ['Personas que buscan una cura médica instantánea sin proceso.', "Quienes prefieren la motivación 'tóxica' de alto impacto y gritos.", 'Aquellos que no están dispuestos a dedicar 5 minutos de quietud al despertar.'];
  return <section className="py-20 md:py-24 px-6 bg-cream" data-id="element-134">
      <div className="max-w-5xl mx-auto" data-id="element-135">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-136">
          {/* Who is it for */}
          <div data-id="element-137">
            <FadeIn data-id="element-138">
              <h2 className="font-serif text-2xl md:text-3xl text-navy mb-8 flex items-center gap-3" data-id="element-139">
                <span className="w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center text-sage" data-id="element-140">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-141">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-142" />
                  </svg>
                </span>
                Para quién es esto
              </h2>
            </FadeIn>
            <div className="space-y-4" data-id="element-143">
              {isFor.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-144">
                  <div className="flex items-start gap-3" data-id="element-145">
                    <div className="w-1.5 h-1.5 rounded-full bg-sage mt-2.5 flex-shrink-0" data-id="element-146"></div>
                    <p className="text-navy/80 leading-relaxed" data-id="element-147">{item}</p>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          {/* Who is it NOT for */}
          <div data-id="element-148">
            <FadeIn delay={0.2} data-id="element-149">
              <h2 className="font-serif text-2xl md:text-3xl text-navy mb-8 flex items-center gap-3 opacity-80" data-id="element-150">
                <span className="w-8 h-8 rounded-full bg-red-900/10 flex items-center justify-center text-red-900/50" data-id="element-151">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-152">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-153" />
                  </svg>
                </span>
                Para quién NO es
              </h2>
            </FadeIn>
            <div className="space-y-4" data-id="element-154">
              {isNotFor.map((item, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-155">
                  <div className="flex items-start gap-3 opacity-80" data-id="element-156">
                    <div className="w-1.5 h-1.5 rounded-full bg-navy/30 mt-2.5 flex-shrink-0" data-id="element-157"></div>
                    <p className="text-navy/70 leading-relaxed" data-id="element-158">{item}</p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}